export const motionClasses = {
  interactive:
    'transition-all duration-200 ease-out motion-reduce:transform-none motion-reduce:transition-none',
  lift: 'transition-all duration-200 ease-out hover:-translate-y-0.5 motion-reduce:transform-none motion-reduce:transition-none',
  subtleControl: 'transition-colors duration-200 ease-out motion-reduce:transition-none',
  collapsible: 'grid transition-all duration-500 ease-out motion-reduce:transition-none',
  drawer: 'transition-transform duration-300 ease-out motion-reduce:transition-none',
  pulse: 'animate-pulse motion-reduce:animate-none',
} as const;

export const surfaceClasses = {
  card: 'shadow-[0_1px_3px_color-mix(in_oklch,var(--color-foreground)_3%,transparent),0_10px_20px_-8px_color-mix(in_oklch,var(--color-foreground)_8%,transparent)]',
  cardHover:
    'hover:shadow-[0_20px_30px_-10px_color-mix(in_oklch,var(--color-foreground)_14%,transparent)]',
  cardSelected:
    'ring-2 ring-foreground shadow-[0_25px_50px_-12px_color-mix(in_oklch,var(--color-foreground)_20%,transparent)]',
  sidePanel:
    'shadow-[6px_0_24px_-12px_color-mix(in_oklch,var(--color-foreground)_28%,transparent)]',
  glowSuccess: 'shadow-[0_0_8px_color-mix(in_oklch,var(--color-success)_60%,transparent)]',
  glowWarning: 'shadow-[0_0_8px_color-mix(in_oklch,var(--color-warning)_65%,transparent)]',
  glowDanger: 'shadow-[0_0_8px_color-mix(in_oklch,var(--color-destructive)_55%,transparent)]',
} as const;
